import 'fetch-polyfill';
import axios from 'axios';
import API from '../../APIconfig';

import {
  asyncActionStart,
  asyncActionFinish,
  asyncActionError
} from '../async/asyncActions';

import {
  toastr
} from 'react-redux-toastr';

import {
  GENERATE_OTP_BANK,
  GET_BANKS,
  ACCOUNT_ADDED,
  ACCOUNT_UPDATED,
  SELECT_ACCOUNT,
} from './accountConstants';


// Token is required for this API
/**
 * @description Get all bank account of user
 * @param {*} csrfRequestIdentifier
 */
export const getBanks = (csrfRequestIdentifier, token, loader) => {
  return async dispatch => {
    try {
      dispatch(asyncActionStart("Fetching Bank Accounts . . .", loader, 'getBankAccount'));

      const banks = await axios.get(API.bank.getBanks.url, {
        'headers': {
          'Content-Type': 'application/json',
          'userMachineIdentifier': 'Mac',
          'UserAgent': navigator.userAgent,
          'fcChannel': API.fcChannel,
          'token': token,
          csrfRequestIdentifier,
        }
      });

      if (banks.errorMessage) {
        toastr.error(`Unable to fetch accounts, please try again! ${banks.errorMessage}`);
      }

      dispatch({
        type: GET_BANKS,
        payload: banks,
      });

      dispatch(asyncActionFinish());
    } catch (error) {
      console.log(error);
      toastr.error(`Unable to fetch accounts, please try again! ${error}`);
      dispatch(asyncActionError());
    }
  }
}

/**
 * @description account added action
 * @param {object} data
 * @param {object} formData
 * @param {string} csrfRequestIdentifier
 */
export const accountAdded = (data, formData, csrfRequestIdentifier, token) => {

  return dispatch => {
    dispatch(getBanks(csrfRequestIdentifier, token));

    toastr.success('Account added successfully');

    dispatch({
      type: ACCOUNT_ADDED,
      payload: {
        data,
        formData,
        csrfRequestIdentifier,
      }
    });
  }
};

/**
 * @description account updated action
 * @param {object} data
 * @param {object} formData
 * @param {string} csrfRequestIdentifier
 */
export const accountUpdated = (data, formData, csrfRequestIdentifier, token) => {
  return dispatch => {
    dispatch(getBanks(csrfRequestIdentifier, token));

    toastr.success('Account updated successfully');

    dispatch({
      type: ACCOUNT_UPDATED,
      payload: {
        data,
        formData,
        csrfRequestIdentifier,
      }
    });
  }
};

/**
 * @description set selected bank in app state
 * @param {object} account
 */
export const selectAccount = (account) => {
  return {
    type: SELECT_ACCOUNT,
    payload: account,
  }
};

export const deleteOTP = () => {
  return {
    type: GENERATE_OTP_BANK,
    payload: {}
  }
}

export const generateOTP = (api, payload, csrfRequestIdentifier = '', callback) => {
  return async dispatch => {
    try {
      dispatch(asyncActionStart("", false, 'generateOTP'));
      const reqObject = {
        method: api.method,
        body: JSON.stringify(payload),
        headers: new Headers({
          'Content-type': 'application/json',
          csrfRequestIdentifier,
        }),
      };

      const OTP = await fetch(api.url, reqObject).then(response=>response.json());

      dispatch({
        type: GENERATE_OTP_BANK,
        payload: OTP,
      });

      if (!OTP.error) {
        callback();
      }

      dispatch(asyncActionFinish());

    } catch (error) {
      toastr.error('OTP Service', `Error while generating OTP, Internal Server Error!`);
      console.log(error);
      dispatch(asyncActionError());
    }
  };
}